<template>
    <transition name="slide" mode="out-in">
        <div class="register-success-tbf">
            <div class="success-modal">
                <div class="content-modal">
                    <div class="fe-btn-translation p-absolute" @click="$root.$emit('open_modal_translation', 'Reset Pasword Success', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

                    <div class="content-icon reset">
                        <img src="/build/images/bird_key.png" class="reset"/>
                    </div>
                    <div class="title">{{ $t('reset_password_success.title') }}</div>
                    <div class="container-content-modal">
                        <div class="container-message">
                            {{ $t('reset_password_success.description') }}
                        </div>
                    </div>
                    <div class="action-form">
                        <button type="submit" class="button-tbf-blue" @click="redirect()">
                            <div class="lds-ring white-spin"><div></div><div></div><div></div><div></div></div>
                                {{ $t('reset_password_success.button-action') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
	data(){
		return {
            arrayTranslations: [
                'reset_password_success.title',
                'reset_password_success.description',
                'reset_password_success.button-action'
            ]
		}
	},
	methods: {
        redirect() {
            this.$router.push("/login");
        }
	}
}
</script>